import type { ReactNode } from 'react';

import { Color } from '@tmh-website/shared/colors';

import * as Styled from './TextFadeOverflowRolling.styles';

export interface TextFadeOverflowRollingProps {
  fadeColor: Color;
  children: ReactNode;
  /**
   * The duration of one cycle in ms
   */
  duration?: number;
}

const TextFadeOverflowRolling = ({ fadeColor, duration = 5000, children, ...props }: TextFadeOverflowRollingProps) => {
  return (
    <Styled.Container {...props}>
      <Styled.Fade $position='left' $fadeColor={fadeColor} />
      <Styled.Fade $position='right' $fadeColor={fadeColor} />
      <Styled.TextContainer $duration={duration}>
        {children}
        <Styled.TextDuplicate>{children}</Styled.TextDuplicate>
      </Styled.TextContainer>
    </Styled.Container>
  );
};

export default TextFadeOverflowRolling;
